import { HttpInterceptors } from "./http.interceptor";

export class SchedulingRecurringService extends HttpInterceptors {
	async createSchedulingRecurring (payload) {
		const response = await this.axios.post("schedulingRecurring/createSchedulingRecurring", payload);
		return response.data;
	}

	async recoverSchedulingRecurring (payload) {
		const response = await this.axios.patch("schedulingRecurring/recoverSchedulingRecurring", payload);
		return response.data;
	}

	async updateSchedulingRecurring (payload) {
		const response = await this.axios.patch("schedulingRecurring/updateSchedulingRecurring", payload);
		return response.data;
	}
}
